<template>
  <v-card>
    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.EDIT') }} {{ $t('RELATED_PERSONS.ITEM') }}</span
      >
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field :label="`${name}`" disabled />

        <v-text-field
          :value="`${form.inline}`"
          :label="`${$t('RELATED_PERSONS.ITEM')} *`"
          disabled
        />

        <v-autocomplete
          v-model="form.relationship_id"
          :items="relationships"
          :loading="!!!relationships"
          item-value="id"
          item-text="name"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.RELATIONSHIP')} *`"
          :error-messages="errors.relationship_id"
          @input="updateValue('relationship_id', $event)"
        ></v-autocomplete>

        <v-switch v-model="form.key" :label="$t('RELATIONS.KEY')"></v-switch>

        <v-textarea
          v-model="form.notes"
          outlined
          counter="80"
          :rules="rules.textDescription80"
          :label="$t('RELATIONS.NOTES')"
          :error-messages="errors.notes"
          @input="updateValue('notes', $event)"
        ></v-textarea>

        <v-autocomplete
          v-model="form.priority"
          :items="prioritiesList"
          item-text="title"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('RELATIONS.PRIORITY')} *`"
          :error-messages="errors.priority"
          @input="updateValue('priority', $event)"
        ></v-autocomplete>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined class="mr-2" text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn depressed color="error" @click="remove">
              {{ $t('BUTTON.DELETE') }}
            </v-btn>
            <confirm-dialog ref="confirm" />
            <v-spacer />
            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
            >
              {{ $t('BUTTON.UPDATE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  requiredSelectNotArray,
  textDescription80
} from '@/modules/_global/variables/rules.js';
import priority from '@/modules/relations/components/mixins/priority';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'RelationsPersonEdit',

  components: {
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  mixins: [formEditable, priority],

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    relationModified: {},
    error: null,
    valid: true,
    relationships: [],
    priorities: [],
    rules: { requiredSelectNotArray, textDescription80 }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.$store
      .dispatch('relation/retrieveRelationshipsWithPerson')
      .then(response => {
        this.relationships = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    this.priorities = this.$store.state.relation.priorities;
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$emit('update', { ...this.form });
      }
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            this.$emit('remove');
          }
        });
    }
  }
};
</script>
